import { z } from 'zod';

export const CandidateReputationFormSchema = z.object({
  showCandidateReputation: z.boolean(),
  submissionComments: z.string().nullish(),
});

export type CandidateReputationFormType = z.infer<
  typeof CandidateReputationFormSchema
>;

export const CandidateReputationCheckboxSchema =
  CandidateReputationFormSchema.pick({
    showCandidateReputation: true,
  });

export const CandidateReputationCommentsSchema =
  CandidateReputationFormSchema.pick({
    submissionComments: true,
  });
